import axiosInstance from "./axiosInstance";

// Get all payoss
export const cancelPayment = async (data) => {
    const response = await axiosInstance.get("/payos/cancel-url", {
        params: data
    });
    return response.data;
};

// Create a new payos
export const returnPayment = async (data) => {
    const response = await axiosInstance.get("/payos/return-url", {
        params: data
    });
    return response.data;
};
